
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/noValidFolio',['Vue', 'vue!../reusableComponents/segment', 'vue!../reusableComponents/userForm'],function(Vue, segment, userForm){
        return {
            name:'noValidFolio',
            template:template,
            props: ['errorMessage','loggedInWithOtherUser'],
            components: {
                segment: segment,
                'user-form': userForm
            },
            data: function(){
                return {
                    showAllFields: false,
                    customerDetails: this.generateUserModel()
                }
            },
            methods: {
                reLoginWithFolio: function (e) {
                    this.$emit('relogin')
                }
            },

        }
    })
})('<div v-if="loggedInWithOtherUser" > <p>{{localization.roomReservation.pmsCheckIn.errors.loggedInAsOtherAccountPreText + $globalParameters.pmsFolioId+ \' \' +localization.roomReservation.pmsCheckIn.errors.loggedInAsOtherAccountPostText +$globalParameters.pmsFolioId}}</p> <button v-on:click="reLoginWithFolio" class="btn btn-primary">{{localization.roomReservation.pmsCheckIn.loginWithLabel+$globalParameters.pmsFolioId}}</button> </div> <div v-else>{{errorMessage}}</div>');
